import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/lib/site";

const services = [
  {
    tag: "01 · One on One",
    title: "Coaching for Adults & College Students with ADHD",
    body:
      "Co-create playful, practical scaffolding so you can follow your curiosities, meet goals, and flourish on your own terms.",
    img: SITE.serviceImages.adults,
  },
  {
    tag: "02 · One on One",
    title: "Coaching for Parents of Neurodiverse Children",
    body:
      "A strengths-based partnership where together we craft consistent supports that honor your child's brain wiring while easing your daily life.",
    img: SITE.serviceImages.parents,
  },
  {
    tag: "03 · Group",
    title: "Group Training for Parents & Educators",
    body:
      "Lively, practical sessions to design ADHD-friendly spaces and strategies that amplify strengths and reduce consequences.",
    img: SITE.serviceImages.group,
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl reveal">
          <span className="text-xs md:text-sm uppercase tracking-[0.28em] text-brand-coral font-semibold">
            I'm here to help you thrive
          </span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl lg:text-6xl text-brand-navy leading-[1.05] tracking-tight">
            Three ways we can <em className="italic">work together</em>.
          </h2>
        </div>

        <div className="mt-14 md:mt-20 grid lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((s, i) => (
            <article
              key={s.title}
              data-testid={`service-card-${i}`}
              className="reveal group rounded-3xl overflow-hidden bg-white border border-brand-sage/15 shadow-[0_8px_30px_rgba(47,66,80,0.05)] hover:-translate-y-2 hover:shadow-[0_24px_48px_rgba(47,66,80,0.08)] transition-all duration-500 flex flex-col"
            >
              <div className="aspect-[5/4] overflow-hidden bg-brand-sage/20">
                <img
                  src={s.img}
                  alt=""
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-7 md:p-8 flex flex-col flex-1">
                <div className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold">
                  {s.tag}
                </div>
                <h3 className="mt-3 font-serif text-2xl md:text-[28px] leading-snug text-brand-navy">
                  {s.title}
                </h3>
                <p className="mt-4 text-base text-brand-navy/70 leading-relaxed flex-1">
                  {s.body}
                </p>
                <a
                  href={SITE.calendly}
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid={`service-cta-${i}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-brand-sageDeep hover:text-brand-coral transition group/cta"
                >
                  Start a conversation
                  <ArrowUpRight
                    size={16}
                    className="transition-transform duration-300 group-hover/cta:translate-x-0.5 group-hover/cta:-translate-y-0.5"
                  />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
